/**
 * DevExtreme (esm/__internal/grids/grid_core/master_detail/const.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const CLASSES = {
  detailRow: "dx-master-detail-row",
  detailCell: "dx-master-detail-cell",
  detailContainer: "master-detail-container",
  cellFocusDisabledClass: "dx-cell-focus-disabled",
  rowLines: "dx-row-lines"
};